import { EmbeddedChat } from "@embeddedchat/react";
import { Box, Grow, IconButton, styled, TextField } from "@mui/material";
import { axios } from "../axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import _cookies from "../../utils/_cookies";
import { ChatBubble, Close } from "@mui/icons-material";
import { useState } from "react";
import Form from "../../../ui/components/Form";

const getRoomsInfo = async () => {
  const res = await axios.cadernoVirtualBase(
    "https://api.cadernovirtual.com.br/api/v1/rooms.get",
    {
      headers: {
        "X-Auth-token": "x1oU8HnGP-Zi-s-VuJUZpeCv6pJEMfYck_fFfaEueH_",
        "X-User-Id": "ss4dEsw8YfKS7we9R",
      },
    }
  );
  return res;
};

export const useRoomsInfo = () => {
  return useQuery({ queryKey: ["rocketChatRooms"], queryFn: getRoomsInfo });
};

const getChatUsers = async () => {
  const res = await axios.cadernoVirtualBase(
    "https://api.cadernovirtual.com.br/api/v1/users.list",
    {
      headers: {
        "X-Auth-token": "N31HJ9O4UVwPbAL_eolYp0qyJnZfIuTYs0NgMM9ao4Z",
        "X-User-Id": "ss4dEsw8YfKS7we9R",
      },
    }
  );
  return res;
};

export const useChatUsers = ({}) => {
  return useQuery({ queryKey: ["rocketChatUsers"], queryFn: getChatUsers });
};

const ChatIcon = styled(IconButton)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
}));

const ChatWrapper = styled("span")(({ theme }) => ({
  position: "fixed",
  bottom: 7,
  right: 7,
}));

const ChatIframe = styled("iframe")(({ theme }) => ({
  width: "100%",
  height: "100%",
}));

const Chat = () => {
  const [chatOpen, setChatOpen] = useState(false);
  const { data } = useChatUsers({});

  const handleOpen = () => {
    setChatOpen(true);
  };

  const handleClose = () => {
    setChatOpen(false);
  };

  const handleClickChatBubble = () => {
    if (chatOpen) {
      handleClose();
    } else {
      handleOpen();
    }
  };

  return (
    <ChatWrapper>
      <Box
        sx={{
          p: 2,
          backgroundColor: "red",
          width: "500px",
          height: "500px",
          position: "absolute",
          float: "right",
          transform: "translate(-100%,-100%)",
        }}
      >
        {/* <Form>
          {() => {
            return <>
            <TextField />
            </>;
          }}
        </Form> */}
        <EmbeddedChat
          moreOpts
          anonymousMode={false}
          host="https://api.cadernovirtual.com.br/"
          roomId="TnhYSiARcQHTxKxdNss4dEsw8YfKS7we9R"
          height={"100%"}
          // auth={{
          //   flow: "TOKEN",
          //   credentials: {
          //     serviceName: "your-service-name",
          //     accessToken: _cookies.getItem("auth").token,
          //     expiresIn: 3600,
          //   },
          // }}
        />

        {/* <ChatIframe
          src={`https://api.cadernovirtual.com.br/channel/general?layout=embedded`}
        /> */}
      </Box>
      <ChatIcon size="large" onClick={handleClickChatBubble}>
        {chatOpen ? <Close /> : <ChatBubble />}
      </ChatIcon>
    </ChatWrapper>
  );
};

export default Chat;
